import BaseCollectionService from "./base.collection.service";

class AtlasFileCategoryService extends BaseCollectionService {
  constructor() {
    super("document-categories");
  }
}

export default new AtlasFileCategoryService();
